import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { queryGetCotizationList } from '../apiPricing/cotizacion.service';
import { Observable, first, map } from 'rxjs';
import IHttpResponse from '../../interfaces/shared/IHttpResponse';
import { IQuotation } from 'src/app/state/quotation/quotation.models';
import { IGetCoberturasResponse } from '../../interfaces/response/IGetCoberturasResponse';
import { ICatalogoResponse } from '../../interfaces/response/ICatalogoResponse';
import {
  ICoverage,
  ICoverageDetails,
} from 'src/app/state/coverages/coverages.models';
import { IPartner } from '../../interfaces/shared/IPartner.interface';
import { queryObjectsCotization } from '../apiProducto/objetos.service';

@Injectable({
  providedIn: 'root',
})
export class LandingService {
  baseUrl = `${environment.proxy.root}/${environment.proxy.api}`;

  apiUrls = {
    pricing: `${this.baseUrl}/api-pricing/api`,
    product: `${this.baseUrl}/api-product/api`,
    policy: `${this.baseUrl}/api-policy/api`,
    person: `${this.baseUrl}/api-person/api`,
  };

  constructor(private http: HttpClient) {}

  // API-PRODUCT
  getObjetsCotizationPolicy(data?: queryObjectsCotization) {
    let query;

    if (data) query = this.createQuery(data);

    const url = `${this.apiUrls.product}/ObjetosCotizacionPoliza/ObjetosCotizacionPoliza?${query}`;

    return this.http.get<any>(url);
  }

  getCoberturasObligatoriasByIdCotizacion(
    idCotizacion: number,
    includePackages: number[] = [1, 2, 3]
  ): Observable<ICoverage[]> {
    const query_params = { includePackages: includePackages };
    const params = this.add_params(query_params);

    const url = `${this.apiUrls.product}/Coberturas/${idCotizacion}/ObligatoriasPorCotizacion/catalogo`;

    return this.http
      .get<IGetCoberturasResponse>(url, params)
      .pipe(map((resp) => resp.data || []));
  }

  getCoberturasOpcionales(
    idCotizacion: number,
    includePackages: number[] = [1, 2, 3]
  ): Observable<ICoverage[]> {
    const query_params = { includePackages: includePackages };
    const params = this.add_params(query_params);

    const url = `${this.apiUrls.product}/Coberturas/${idCotizacion}/opcionales/catalogo`;

    return this.http
      .get<IGetCoberturasResponse>(url, params)
      .pipe(map((resp) => resp.data || []));
  }

  getCoverageInfoText(aliasPantalla: string, idProducto: number) {
    const url = `${this.apiUrls.product}/Pantallas/pantallaInfo?AliasPantalla=${aliasPantalla}&IdProducto=${idProducto}`;

    return this.http
      .get<ICatalogoResponse<ICoverageDetails[]>>(url)
      .pipe(first());
  }

  // API-PRICING
  getCotizationList(
    data?: queryGetCotizationList
  ): Observable<IHttpResponse<IQuotation[]>> {
    let query;

    if (data) query = this.createQuery(data);

    const url = `${this.apiUrls.pricing}/Cotizacion/GetV_Cotizaciones?${query}`;

    return this.http.get<IHttpResponse<IQuotation[]>>(url);
  }

  acceptCotizationLanding(cotizationId) {
    const url = `${this.apiUrls.pricing}/Cotizacion/${cotizationId}/update/Aceptada`;

    return this.http.post<any>(url, null);
  }

  // API-POLICY
  setConsentimientosLocalJob(body) {
    const url = `${this.apiUrls.policy}/Consentimientos/locales/job`;

    return this.http.post<any>(url, body).pipe(map((resp) => resp.data));
  }

  // API-PERSON
  getPartnerInfo(idEntidad: number): Observable<any> {
    const url = `${this.apiUrls.person}/Entidad/${idEntidad}`;
    return this.http.get<IPartner>(url).pipe(first());
  }

  private add_params(params: any): { params: HttpParams } {
    return {
      params: new HttpParams({
        fromObject: {
          ...params,
        },
      }),
    };
  }

  private createQuery(data) {
    const query = Object.keys(data)
      .map((key) => `${key}=${data[key]}`)
      .join('&');

    return query;
  }
}
